var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMenuType(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 20,
    viewBox: "0 0 17 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 20C2.45 20 1.97917 19.8042 1.5875 19.4125C1.19583 19.0208 1 18.55 1 18V16H0V14H1V11H0V9H1V6H0V4H1V2C1 1.45 1.19583 0.979167 1.5875 0.5875C1.97917 0.195833 2.45 0 3 0H15C15.55 0 16.0208 0.195833 16.4125 0.5875C16.8042 0.979167 17 1.45 17 2V18C17 18.55 16.8042 19.0208 16.4125 19.4125C16.0208 19.8042 15.55 20 15 20H3ZM3 18H15V2H3V4H4V6H3V9H4V11H3V14H4V16H3V18ZM6.5 15H8V11C8.43333 10.8833 8.79167 10.6458 9.075 10.2875C9.35833 9.92917 9.5 9.525 9.5 9.075V5H8.5V8.775H7.75V5H6.75V8.775H6V5H5V9.075C5 9.525 5.14167 9.92917 5.425 10.2875C5.70833 10.6458 6.06667 10.8833 6.5 11V15ZM12 15H13.5V5C12.6667 5 11.9583 5.29167 11.375 5.875C10.7917 6.45833 10.5 7.16667 10.5 8V11H12V15Z",
    fill: "#0080A6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuType);
export default __webpack_public_path__ + "static/media/menuType.b6e39c707dc20f53bae58eb27caf3631.svg";
export { ForwardRef as ReactComponent };